export const ADMIN_ROUTE = '/admin'
export const LOGIN_ROUTE = '/login'
export const PROFILE_ROUTE = '/profile'
export const HISTORY_ROUTE = '/history'
export const POSTING_ROUTE = '/posting'
export const REGISTRATION_ROUTE = '/registration'
export const HOME_ROUTE = '/'
export const CATALOG_ROUTE = '/catalog'
export const PRODUCT_ROUTE = '/product'
export const BASKET_ROUTE = '/basket'
export const CHECKOUT_ROUTE = '/checkout'
export const CHECKOUT_DELIVERING_ROUTE = '/to_delivering'
export const MAP_ROUTE = '/map'
export const ABOUT_ROUTE = '/about'
export const PAY_AND_SHIP_ROUTE = '/pay_and_ship'
export const WARRANTY_ROUTE = '/warranty'
export const REFUND_ROUTE = '/refund'
export const CONTACTS_ROUTE = '/contacts'
export const SERVICES_ROUTE = '/services'
export const BRANDS_ROUTE = '/brands'
export const POLICY_OPD_ROUTE = '/policy_opd'
export const PAY_SUCCESS = '/pay_success'
export const PAY_FAIL = '/pay_fail'
export const POSTING_SUCCESS = '/success_posting'
export const PAY_PAGE = '/pay_page'
export const XZ_ROUTE = '/.well-known/acme-challenge/test.txt'
export const SEARCH_PAGE = '/search'
export const AURUS_PAGE = '/aurus'
export const PROMOTIONS_PAGE = '/promotions'

